import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import { MenuItem, MenuList } from "material-ui/Menu";

import Wrapper from "../common/Wrapper";
import Header from "../common/Header";
import Loader from "../Parts/Loader";
import { NotificationType } from "../../constants/ComponentTypes";
import { NOTIFICATIONS_PER_PAGE } from "../../constants/Constants";
import Pagination from "../common/Pagination";
import { containsHtmlElement } from "../../utils/utils";

import Bell from "../Icons/Bell";

import * as moment from "moment";

const styles = () => ({
  root: {
    width: "100%",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    overflowY: "auto",
  },

  main: {
    background: "#FAFAFA",
    flex: 1,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },

  content: {
    width: "85%",
    maxWidth: "1222px",
    margin: "30px auto 90px auto",
    boxSizing: "border-box",
  },

  box: {
    width: "100%",
    padding: "22px 25px 32px 25px",
    background: "#FFFFFF",
    boxShadow: "0px 1px 2px #0000001F",
    borderRadius: "4px",
    boxSizing: "border-box",
  },

  title: {
    fontSize: "20px",
    color: "#181819",
    fontWeight: "bold",
    paddingBottom: "15px",
    borderBottom: "1px solid #E7E9EB",
    marginBottom: "28px",
    display: "flex",
    alignItems: "center",
    width: "100%",
  },

  unreadDotContainer: {
    minWidth: "12px",
  },

  unreadDot: {
    background: "#1A65FF",
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    display: "block",
    boxShadow:
      "0 12px 28px 0 rgba(0,0,0,0.15),0 2px 4px 0 rgba(0,0,0,0.15),inset 0 0 0 1px rgba(0,0,0,0.15)",
  },

  message: {
    marginBottom: "8px",
    fontSize: "15px",
    whiteSpace: "normal",
    "& p": {
      padding: 0,
      margin: 0,
    },
  },

  row: {
    borderBottom: "1px solid #D8DBDF",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "15px",
    height: "unset",
    minWidth: "50px",
    "&:hover": {
      backgroundColor: "rgba(26,101,255,.05)",
    },
  },

  emptyContainer: {
    height: "160px",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  icon: {
    width: "32px",
    height: "32px",
    minWidth: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "8px",
  },

  paginationContainer: {
    margin: "40px 0px 0px 0px",
  },

  messageBody: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "pre-wrap",
    display: "-webkit-box",
    "-webkit-line-clamp": 3,
    "-webkit-box-orient": "vertical",
  },
});

class Notifications extends React.Component {
  componentDidMount() {
    this.props.getNotifications({
      paging: 1,
      per_page: NOTIFICATIONS_PER_PAGE,
      page: 1,
    });
  }

  handleClick = (item) => () => {
    const dayCountAtWeek = 7;
    if (
      item.type === NotificationType.EXE_FILTER_NEW_EXE &&
      item.executive_list_filter !== null
    ) {
      this.props.postNotificationsMark(item.id, { read_flag: 1 });
      this.props.goTo("/executive-list", {
        filter: {
          ...item.executive_list_filter.filter,
          created_at_from: moment().subtract(dayCountAtWeek, "day").format("YYYY-MM-DD"),
        },
        query: {},
      });
    } else if (item.type === NotificationType.SYSTEM_NOTIF || item.type === NotificationType.PENDING_APPOINTMENT_SCHEDULE) {
      // 日程未確定の商談の通知も、本文をそのままダイアログで見せる
      this.props.postNotificationsMark(item.id, { read_flag: 1 });
      this.props.toggleSystemNotificationDialog(item);
    } else if (item.type === NotificationType.RECOMMEND_RELOCATION_PERSONNEL) {
      this.props.postNotificationsMark(item.id, { read_flag: 1 });
      this.props.toggleRecommendRelocationPersonnelNotificationDialog(item);
    }
  };

  render() {
    const { classes, notifications, isLoadingNotifications, pageInfo } =
      this.props;

    return (
      <Wrapper className={classes.root}>
        <Header title="通知" type="dark" hasBackBtn={false} />
        <div className={classes.main}>
          <div className={classes.content}>
            <div className={classes.box}>
              <div className={classes.title}>
                <div className={classes.icon}>
                  <Bell width={27} height={27} color="#040E35" />
                </div>
                通知
              </div>

              <div className={classes.listContainer}>
                {(() => {
                  if (!notifications || notifications.length === 0) {
                    if (isLoadingNotifications) {
                      return (
                        <div className={classes.emptyContainer}>
                          <Loader type="dark" />
                        </div>
                      );
                    } else {
                      return (
                        <div className={classes.emptyContainer}>
                          通知がありません。
                        </div>
                      );
                    }
                  } else {
                    return (
                      <MenuList role="menu" style={{ padding: 0 }}>
                        {notifications.map((item, i) => (
                          <MenuItem
                            key={i}
                            className={classes.row}
                            onClick={this.handleClick(item)}
                          >
                            <div className={classes.messageContainer}>
                              <div className={classes.message}>
                                {containsHtmlElement(item.message_head) ? (
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: item.message_head,
                                    }}
                                  />
                                ) : (
                                  <p>{item.message_head}</p>
                                )}
                              </div>

                              {!!item.message_body && (
                                <div className={classes.message}>
                                  {containsHtmlElement(item.message_body) ? (
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: item.message_body,
                                      }}
                                    />
                                  ) : (
                                    <p className={classes.messageBody}>
                                      {item.message_body}
                                    </p>
                                  )}
                                </div>
                              )}
                              <Typography variant="body1">
                                {moment(item.created_at).format(
                                  "YYYY年MM月DD日"
                                )}
                              </Typography>
                            </div>
                            <div className={classes.unreadDotContainer}>
                              {!item.read_flag && (
                                <span className={classes.unreadDot} />
                              )}
                            </div>
                          </MenuItem>
                        ))}
                      </MenuList>
                    );
                  }
                })()}
              </div>
            </div>
            {notifications.length > 0 && pageInfo && (
              <div className={classes.paginationContainer}>
                <Pagination
                  currentPage={pageInfo.current_page}
                  lastPage={pageInfo.last_page}
                  total={pageInfo.total}
                  perPage={NOTIFICATIONS_PER_PAGE}
                  showLastPage={true}
                  disabled={isLoadingNotifications}
                  disableNavigation={false}
                  onChange={(data) => {
                    this.props.getNotifications({
                      paging: 1,
                      per_page: NOTIFICATIONS_PER_PAGE,
                      page: data["page"],
                    });
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </Wrapper>
    );
  }
}

Notifications.propTypes = {
  classes: PropTypes.object.isRequired,
  getNotifications: PropTypes.func.isRequired,
  postNotificationsMark: PropTypes.func.isRequired,
  toggleSystemNotificationDialog: PropTypes.func.isRequired,
  toggleRecommendRelocationPersonnelNotificationDialog: PropTypes.func.isRequired,
  notifications: PropTypes.array,
  isLoadingNotifications: PropTypes.bool,
  pageInfo: PropTypes.object,
  goTo: PropTypes.func.isRequired,
};

export default withStyles(styles)(Notifications);



// WEBPACK FOOTER //
// ./src/components/Notifications/Notifications.jsx